import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOther = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 695 897",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		transform: "translate(-48.907 -55.626)",
		children: /* @__PURE__ */ _jsx("path", { d: "m743.91 952.63v-897h-695v897h695zm-346.69-7.6562c-51.912 1e-5 -94.062-32.724-94.062-73.031s42.151-73.031 94.062-73.031 94.031 32.724 94.031 73.031-42.12 73.031-94.031 73.031zm85.062-219.06h-171.03v-22.312c-2.3e-4 -37.951 4.2985-68.766 12.906-92.438s23.637-45.281 40.656-64.844 41.998-26.327 101.47-75.625c31.691-25.822 55.281-77.168 55.281-98.688 2.2123-56.922-13.939-79.346-34.562-99.969-22.674-19.677-60.671-30.062-91-30.062-27.779 6.8e-4 -68.482 8.0932-87.781 25.375-25.938 17.283-65.222 73.692-57.031 130.53l-194.53 1.7188c1e-5 -157.21 29.39-198.7 99-263.03 67.397-54.377 126.56-73.281 243.88-73.281 89.718 2e-5 161.88 17.803 214.31 53.406 71.207 48.125 122.31 111.2 122.31 230.12-6.9e-4 44.321-19.174 90.766-43.094 128.31-18.389 30.909-60.35 66.474-118.19 104.44-42.836 25.769-66.695 53.118-77.062 72.094s-15.532 43.733-15.531 74.25z" })
	})]
});
const ForwardRef = forwardRef(SvgOther);
export { ForwardRef as ReactComponent };
